/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import Banner from './Banner';
import CtaForm from './CtaForm';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { quint } from '@entrata/portals-common/lib/styled-utils';
import { requestToken } from 'redux/modules/user';
import { connect } from 'react-redux';

const StyledDiv = styled('div')`
  transition: all ${({ duration, delay }) => `${duration}ms ${delay ? `${delay}ms` : ''}`} ${quint.easeInOut};

  padding: 0 16px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: 767px) {
    position: absolute;
    top: 5%;
    width: 100%;
    margin: auto;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 0;
    text-align: center;
  }
`;

const transitions = {
  entering: css`
    opacity: 0;
    transform: scale(0.5);
  `,
  entered: css`
    opacity: 1;
    transform: scale(1);
  `,
  exiting: css`
    opacity: 0.75;
    transform: scale(0.5);
  `,
};

const StyledH1 = styled('h1')`
  color: #f3f5f7;
  display: inline-block;
  opacity: 0.9;
  font-family: ${({ theme }) => theme.fonts.algebraLight};
  line-height: 36px;
  padding: 16px 20px 0 20px;
  font-size: 30px;
  margin: 24px 0;
  text-align: center;

  @media only screen and (max-width: 767px) {
    padding: 0 16px;
    font-size: 24px;
    margin: 40px 0 40px;
    width: 100%;
  }
`;

const BannerCta = ({ productId, subTitle = '', title, token, isAgent, requestToken, quoteVersion, ...rest }) => {
  const [showTransitionEffect, setShowTransitionEffect] = useState(false);

  useEffect(() => {
    setShowTransitionEffect(true);

    if (!token && isAgent && location.pathname.includes('products')) {
      requestToken({
        key: '',
        url: location.host,
      });
    }
  }, []);

  return (
    <Banner {...rest}>
      <Transition in={showTransitionEffect} timeout={500} mountOnEnter unmountOnExit>
        {(status) =>
          showTransitionEffect && (
            <StyledDiv className={transitions[status]} duration={800} delay={200}>
              <StyledH1>{`${title} ${subTitle}`}</StyledH1>
              <CtaForm productId={productId} location={location} blockedDisplay={true} quoteVersion={quoteVersion} />
            </StyledDiv>
          )
        }
      </Transition>
    </Banner>
  );
};

BannerCta.propTypes = {
  alt: PropTypes.string.isRequired,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  requestToken: PropTypes.func.isRequired,
  isAgent: PropTypes.bool,
  token: PropTypes.string,
};

export default connect(
  ({ user: { isAgent, token } }) => ({
    isAgent,
    token,
  }),
  {
    requestToken,
  },
)(BannerCta);
